// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 535 ? "login" : chunkId) + "." + {"31":"36d8493d","535":"09d2e53e","787":"82d7896b"}[chunkId] + ".chunk.js";
};